/**
 * @generated SignedSource<<35699e4b7683073d2036dacafd9b1dc1>>
 * @relayHash 02adc5dac741cd9ffe1aee9e3fd3c94e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 25a2ea9f3205bcf649647225feeecaaeee703b0db75cb537b437e3d010552dd9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CaseNoteEditPageQuery } from './CaseNoteEditPageQuery.graphql';

const node: PreloadableConcreteRequest<CaseNoteEditPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "25a2ea9f3205bcf649647225feeecaaeee703b0db75cb537b437e3d010552dd9",
    "metadata": {},
    "name": "CaseNoteEditPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
